import img1 from '../assests/images/1.jpeg'
import img2 from '../assests/images/2.jpg'
import img3 from '../assests/images/3.jpg'
import img4 from '../assests/images/4.jpg'
import img5 from '../assests/images/5.jpg'
import img6 from '../assests/images/6.jpg'
import img7 from '../assests/images/7.jpg'
import img8 from '../assests/images/8.jpg'
import img9 from '../assests/images/9.jpg'
import img10 from '../assests/images/10.jpg'

export const filmsMocks = [
    {
        id: 0,
        title: "LATE NIGHT WITH THE DEVIL",
        year: "2023",
        starring: "David Dastmalchian, Laura Gordon, Fayssal Bazzi, Ian Bliss",
        description: "Incorporating elements of documentary filmmaking and found footage, the film follows the events of a late-night talk show episode aired on the night of Halloween 1977, during which the host attempts to boost ratings by inviting an allegedly possessed girl onto the show.",
        imageUrl: img1,
        directedBy: "Colin Cairnes, Cameron Cairnes",
        imageDirector: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS7PsayeZJXB4v5y9Z_rWG5nFh9CoNNwmgDAsJteyji4g&s",
        criticsConsensus: "«Delightfully dark, Late Night with the Devil proves possession horror isn't played out -- and serves as an outstanding showcase for David Dastmalchian.»",
        video: "https://youtu.be/TiwvEtimLzQ?si=dOgLJTUC6Cc8Admq"
    },
    {
        id: 1,
        title: "STOPMOTION",
        year: "2023",
        starring: "Aisling Franciosi, Stella Gonet, Tom York, Caoilinn Springall",
        description: "Stopmotion is a horror movie about an animator (Aisling Franciosi) who tries to move out from under the shadow of her abusive mother, working on a new project with the help of a mysterious little girl. Its a gory, hallucinatory, almost experimental work thats unsettling but mesmerizing.",
        imageUrl: img2,
        directedBy: "Robert Morgan",
        imageDirector: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8VQVpCgWIKiICk2mh9RG8sjzH4Cy3mA98O_aXTynjYg&s",
        criticsConsensus: "«Stopmotion takes the conflict between art and artist to chilling, visually thrilling extremes, distinguished by director Robert Morgan's excellent effects work.»",
        video: "https://youtu.be/pCXX7EnoWkw?si=vRWuubNTNa9lYdAG"
    },
    {
        id: 2,
        title: "OUT OF DARKNESS",
        year: "2022",
        starring: "Safia Oakley-Green, Kit Young, Chuku Modu, Iola Evans",
        description: "The premise is simple: this movie is “Alien in the stone age”. It begins with six intrepid early humans washing up on a Highlands beach, all of them quickly and efficiently sketched out as characters. Adem (Chuku Modu) is in charge and evidently sees himself as a mighty leader of men.",
        imageUrl: img3,
        directedBy: "Andrew Cumming",
        imageDirector: "https://encrypted-tbn0.gstatic.com/licensed-image?q=tbn:ANd9GcSk8c2GyAsTq41O0L95oDxLzvecB9Zi4hquLnr2nYLqEcUw4t2cT51oT4zkTD-tMy021k6jmt5LZHpu0PE",
        criticsConsensus: "«A survival thriller reduced to the bare essentials, Out of Darkness offers a chilling reminder that the horror of looming death might be humanity's most universal experience.»",
        video: "https://youtu.be/sU_SQo1wbos?si=vOCjdgpAPP0GKDZv"
    },
    {
        id: 3,
        title: "THE FIRST OMEN",
        year: "2024",
        starring: "Nell Tiger Free, Ralph Ineson, Sonia Braga, Tawfeek Barhom",
        description: "A young American woman is sent to Rome to begin a life of service to the church, but encounters a darkness that causes her to question her faith and uncovers a terrifying conspiracy that hopes to bring about the birth of evil incarnate. Create something to fear.",
        imageUrl: img4,
        directedBy: "Arkasha Stevenson",
        imageDirector: "https://in.bmscdn.com/artist/arkasha-stevenson-2033287-1704371813.jpg",
        criticsConsensus: "«Frequently frightening even as it plays within the confines of a nearly 50-year-old film series, this prequel is The First Omen of a bright future for the franchise in quite some time.»",
        video: "https://youtu.be/lmN1Op8ygno?si=z4ibGfWFhUE6z91b"
    },
    {
        id: 4,
        title: "YOU'LL NEVER FIND ME",
        year: "2023",
        starring: "Brendan Rock, Jordan Cowan, Elena Carapetis, Angela Korng",
        description: "A lonely and troubled older man (Brendan Rock) lives alone in a mobile home. One late and stormy night he's visited by a barefooted young woman (Jordan Cowan) who asks for a ride into town. She claims she came from the beach, but it's unclear how she made it into the man's neighborhood.",
        imageUrl: img5,
        directedBy: "Josiah Allen, Indianna Bell",
        imageDirector: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmBFWvRcF6ZFwk6jGgtSxngC3_iSsOnD10MJb3u3vuIw&s",
        criticsConsensus: "«Visually and sonically distinctive, You'll Never Find Me heightens its spooky atmosphere and claustrophobic setting with a story that'll keep viewers guessing.»",
        video: "https://youtu.be/y1EHT838rrg?si=LrYWlu5u-Y5sPpNe"
    },
    {
        id: 5,
        title: "DOUBLE BLIND",
        year: "2024",
        starring: "Millie Brady, Akshay Kumar, Diarmuid Noyes, Pollyanna McIntosh",
        description: "After an experimental drug trial goes awry, the test subjects face a terrifying side effect: if you fall asleep you die. Trapped in an isolated facility, panic ensues as they try to escape and somehow stay awake. If you fall asleep you die.",
        imageUrl: img6,
        directedBy: "Ian Hunt-Duffy",
        imageDirector: "https://m.media-amazon.com/images/M/MV5BMDkwN2Q1OGMtNGYyZi00MWEzLTg0NjItZjJlNTY5ZWU1YTIwXkEyXkFqcGdeQXVyMjIwMjA0NzI@._V1_.jpg",
        criticsConsensus: "«Double Blind has the kind of plot that is best not to scrutinise in any great detail but in the moment it is credible and intriguing with a strong cast helping to sell the emotional toll of what is unfolding.»",
        video: "https://youtu.be/xB3lk_KGMNw?si=QOmb-R2xEZQaCiS4"
    },
    {
        id: 6,
        title: "SUMMONERS",
        year: "2022",
        starring: "Christine Nyland, McLean Peterson, Larry Fessenden, Madeline Grey DeFreece",
        description: "Jessica Whitman isn't a witch. Not anymore, at least. She left it behind when she left her hometown years ago. When a childhood friend needs her help performing a dark spell, she'll find herself questioning her sense of right and wrong.",
        imageUrl: img7,
        directedBy: "Terence Krey",
        imageDirector: "https://images.squarespace-cdn.com/content/v1/5994c542e4fcb5d90b7239e5/1512161320972-SGPS8FF6BGQGFRXEFSZJ/Terence+Krey",
        criticsConsensus: "«It’s light, but it’s got a heartfelt message of friendship running throughout that bolsters its practical magic personality. Nothing that can quite punch up to the heavy hitters thus far this year or those to come, but a decent choice for a late night grounded and spooky witch tale.»",
        video: "https://youtu.be/lf_EGhRDbWs?si=pYmUz5s0DYwXlUyW"
    },
    {
        id: 7,
        title: "MIDNIGHT PEEPSHOW",
        year: "2022",
        starring: "Derek Nelson, Chiara D'Anna, Bethan Walker, Jamie Bacon",
        description: "Synopsis In MIDNIGHT PEEPSHOW we are introduced to an unnamed Madame who owns and operates a peepshow offering patrons a tailor-made experience wrapped around their deepest desires, fears, and sins. Tonight, it welcomes a businessman who has a unique connection to an extreme fantasy website on the dark web.",
        imageUrl: img8,
        directedBy: "Andy Edwards, Airell Anthony Hayles, Ludovica Musumeci, Jake West",
        imageDirector: "https://movingpicturesfilmclub.files.wordpress.com/2022/08/airell.png?w=557",
        criticsConsensus: "«Midnight Peepshow is an exciting film that plays on human desire. Not only does it toy with the idea of voyeurism but takes that concept to the absolute extreme and is sure to shock the system.»",
        video: "https://youtu.be/C0jjfkRfjQs?si=YvezvrdKWlwWejng"
    },
    {
        id: 8,
        title: "SOMEWHERE QUIET",
        year: "2023",
        starring: "Marin Ireland, Micheál Richardson, Jennifer Kim, Kentucker Audley",
        description: "Follows a woman as she readjusts to normalcy after a kidnapping. Her sense of reality begins to deteriorate when she travels to her husband's family compound.",
        imageUrl: img9,
        directedBy: "Olivia West Lloyd",
        imageDirector: "https://media.gettyimages.com/id/1497054482/photo/new-york-new-york-olivia-west-lloyd-attends-somewhere-quiet-premiere-during-the-2023-tribeca.jpg?s=612x612&w=gi&k=20&c=RC5OID7tt2i90TVy2CgQzjObxnGaHSmePsdUjCfmHxg=",
        criticsConsensus: "No consensus yet.",
        video: "https://youtu.be/UynOoH11-Ws?si=RnLSCB4KAx6lzp04"
    },
    {
        id: 9,
        title: "I SAW THE TV GLOW",
        year: "2024",
        starring: "Justice Smith, Brigette Lundy-Paine, Ian Foreman, Helena Howard",
        description: "Synopsis. A teenager is just trying to make it through life in the suburbs when his classmate introduces him to a mysterious late-night TV show—a vision of a supernatural world beneath their own. In the pale glow of the television, his view of reality begins to crack.",
        imageUrl: img10,
        directedBy: "Jane Schoenbrun",
        imageDirector: "https://www.hollywoodreporter.com/wp-content/uploads/2022/11/Print-Issue-36C-fea_writing-Schoenbrun-Publicity-EMBED-2022.jpg?w=1000",
        criticsConsensus: "«With a distinctive visual aesthetic that enhances its emotionally resonant narrative, I Saw the TV Glow further establishes writer-director Jane Schoenbrun as a rising talent.»",
        video: "https://youtu.be/B4Dqal9OyPE?si=AY_Gb0KUiezQcDux"
    },
]